import { create } from 'zustand';
import { IFavorite } from '../models';

interface IFavoriteState {
  favorites: IFavorite[];
  setFavorites: (favorites: IFavorite[]) => void;
}

export const favoriteStore = create<IFavoriteState>((set) => ({
  favorites: [],
  setFavorites: (favorites: IFavorite[]) => set({ favorites })
}));